import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import InstallerJob from '@/ui/pages/Installer/InstallerJob/InstallerJob';

// HS-1641: one closed job, read-only.
export const Route = createFileRoute('/_dashboard/installer/jobs/$id')({
  beforeLoad: requireRoute('/installer/jobs/$id'),
  component: InstallerJob,
});
